<template>
  <div v-if="displayFilter">
    <input-debounced
        class="w-100"
        :value="value"
        :clearable="clearable"
        :placeholder="placeholders"
        @input="onChange"
    ></input-debounced>
  </div>
</template>

<script>
import BaseFilter from "./single-field-filter";
import InputDebounced from '../../../input-debounced';

export default {
  extends: BaseFilter,

  components: {
    InputDebounced,
  },
}
</script>
